import { IconButtonTestIdFactory } from '../../buttons/interactions';
export const DrawerTestIdFactory = {
    // bases
    getDrawerBase: () => 'drawer',
    getDrawerCloseButtonBase: () => [DrawerTestIdFactory.getDrawerBase(), 'close'].join('-'),
    // for test id generation
    getDrawerTestId: (testId) => [DrawerTestIdFactory.getDrawerBase(), testId].join('-'),
    getDrawerCloseButtonTestId: () => IconButtonTestIdFactory.getIconButtonTestId(DrawerTestIdFactory.getDrawerCloseButtonBase()),
};
